// import { useMemo } from 'react'
import Link from 'next/link'
// import useSWR from 'swr'
import searchFormLink from '@utils/links/searchFormLink'
// import searchFromObject from '@utils/links/searchFromObject'
import withUserLocation from '@hoc/withUserLocation'
// import { apiFetcherPost as apiFetcher } from '@api/apiFetcher'
// import SpinnerBlock from '@components/spinner/SpinnerBlock'
import ListOut from './ListOut'
import resolveCustomLinks from './functions/resolveCustomLinks'
import useT from '@hooks/useTranslation'
import resolveLinkBase from '@utils/links/offerResolveLinkBase' // <- to consider, this adds extra weight to search views

import styles from 'styles/FooterLinks.module.css'

// const BASE = '/api/link_cubes'
const LinkCubes = ({ adtype, buy, linkBase = '',
    query, rent, userLocation }) => {

    const { marka: make, stan: age, lokalizacja } = query
    const { city } = userLocation
    // const getFetchUrl = () => `${BASE}${searchFromObject({ buy, adtype, make, city })}`
    // const fetchUrl = useMemo(() => getFetchUrl(), [
    //     buy, adtype, make, city
    // ])

    // const { data, error } = useSWR(fetchUrl, apiFetcher)

    // if (error) return null
    // if (!data) return <SpinnerBlock height={400} />

    linkBase = resolveLinkBase({ type: adtype, _adtype: adtype, price: { rent: false }}) // no links spec. for rent yet

    const renderStaticLinks = !buy && !rent && ['car_ad', 'truck_ad'].includes(adtype)
    const staticLinkProps = renderStaticLinks && { adtype, city, make, age, lokalizacja }
    const customLinks = resolveCustomLinks(adtype, rent)

    return <RenderLinkCubes
        customLinks={customLinks}
        data={null} // !rent && data ... <- not used
        linkBase={linkBase}
        staticLinkProps={staticLinkProps}
        extra={[{title:'Powrót',items:[{h:'Darmowe ogłoszenia',to:'/'}]}]}
    />
}

function RenderLinkCubes ({ customLinks, data, linkBase, staticLinkProps, extra }) {
    return (
        <Wrapper>
            { customLinks && <CustomLinks customLinks={customLinks} /> }
            { staticLinkProps && <StaticLinks {...staticLinkProps} /> }
            { data && <ListOut id="title" items={data} Component={LinkCube} linkBase={linkBase} /> }
            { extra && <ListOut id="title" items={extra} Component={LinkCube} /> }
        </Wrapper>
    )
}

function Wrapper ({ children }) {
    return (
        <div className={styles.background}>
             <div className={`${styles.container_wrapper} ${styles.grid}`}>
                { children }
            </div>
        </div>
    )
}

function LinkCube ({ title, items, fullrow, linkBase }) {
    if (!items || items.length === 0) return null

    return (
        <div className={fullrow
            ? `${styles.row} ${styles.fullrow}`
            : styles.row}>

            <div className={styles.item}>
                <h2>{title}</h2>
                <ListOut items={items} Component={Cube} linkBase={linkBase} />
            </div>
        </div>
    )
}

function Cube ({ h, to, linkBase }) {
    return ( // skip prefetching multiple low priority links:
        <Link href={linkBase ? `${linkBase}/${to}` : to} prefetch={false}>
            <a title={h}>
                <h3 className="inline-h">{h}</h3>
            </a>
        </Link>
    )
}

function StaticLinks ({ adtype, age, lokalizacja = '' }) {
    // const isCar = adtype === 'car_ad'
    const isTruck = adtype === 'truck_ad'
    const isNew = age === 'Nowy'
    const isUsed = age === 'Uzywany'

    const data = isNew
        ? [10,15,30,50,75,100,150,200,500]
        : [3,5,10,15,20,25,30,40,50,60,70,80,90,100,120,150]

    const samochody = useT('Samochody')
    const nowe = useT('nowe')
    const uzywane = useT('używane')
    const osobowe = useT('osobowe')
    const dostawcze = useT('dostawcze')
    const _do = useT('do')
    const tys = useT('tys.')

    let title = [samochody]

    if (isTruck) title.push(dostawcze)
    else title.push(osobowe)

    if (isNew) title.push(nowe)
    else if (isUsed) title.push(uzywane)

    const titleText = title.join(' ')
    const textStart = `${titleText} ${_do}`

    // const linkArrayItems = [titleText,[],[]] //

    const links = <LinkCube {...{
        title: titleText,
        items: data.map(price => {
            const h = `${textStart} ${price} ${tys} ${lokalizacja}`
            const to = searchFormLink({
                data: { stan: age, 'cena-do': price * 1000, lokalizacja },
                linkBase: resolveLinkBase({ type: adtype, _adtype: adtype, price: { rent: false }}),
                isMakeModelBase: true,
            })

            // linkArrayItems[1].push(h) //
            // linkArrayItems[2].push(to) //

            return { h, to }
        })
    }} fullrow />
    // console.log(linkArrayItems) //
    return links
}

function CustomLinks ({ customLinks }) {
    // const linkArray = [] //
    if (!Array.isArray(customLinks)) return null
    const links = customLinks.map(info => {
        const { title, data, name, link } = info
        // const linkInnerArray = [title,[],[]] //
        const row = <div key={link} className={`${styles.row} ${styles.fullrow}`}>
            <div className={styles.item}>
                <h2>{title}</h2>
                {
                    data.map(item => {
                        const text = name(item)
                        const to = link(item)
                        // linkInnerArray[1].push(text) //
                        // linkInnerArray[2].push(to) //
                        return <Cube h={text} key={text} to={to} />
                    })
                }
            </div>
        </div>
        // linkArray.push(linkInnerArray) //
        return row
    })
    // concat.console.log(linkArray)
    return links
}

export default withUserLocation(LinkCubes)